import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Button, message, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import { supabase } from './supabaseClient';
import { languageOptions } from './variables';



const { Option } = Select;

const SettingsPage = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            setLoading(true);
            const { data: { user } } = await supabase.auth.getUser();
            if (user) {
                const { data, error } = await supabase
                    .from('profiles')
                    .select('*')
                    .eq('id', user.id)
                    .single();

                if (error) throw error;

                const userMainLanguages = Array.isArray(data.main_languages)
                    ? data.main_languages
                    : JSON.parse(data.main_languages || '[]');


                form.setFieldsValue({
                    email: user.email,
                    nickname: data.nickname,
                    preferred_translation: data.preferred_translation,
                    main_languages: userMainLanguages
                });
            }
        } catch (error) {
            message.error('Failed to load profile.');
        } finally {
            setLoading(false);
        }
    };

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const { data: { user } } = await supabase.auth.getUser();
            if (user) {
                // languageOptions에서 선택된 코드에 해당하는 이름 찾기
                const selectedLanguage = languageOptions.find(
                    lang => lang.code === values.preferred_translation
                )?.name || values.preferred_translation;

                const updates = {
                    id: user.id,
                    preferred_translation: selectedLanguage,
                    updated_at: new Date()
                };

                const { error } = await supabase.from('profiles').upsert(updates);

                if (error) throw error;
                message.success('Profile updated successfully.');
            }
        } catch (error) {
            message.error('Failed to update profile.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <div style={{ maxWidth: 600, margin: '0 auto', padding: '20px' }}>
            <Form
                form={form}
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item name="email" label="Email">
                    <Input disabled />
                </Form.Item>
                <Form.Item name="preferred_translation" label={
                    <Tooltip title="Real-time summary and translation and AI support will be provided in the selected language.">
                        Preffered Language <InfoCircleOutlined />
                    </Tooltip>
                }>
                    <Select>
                        {languageOptions.map(lang => (
                            <Option key={lang.code} value={lang.name}>{lang.name}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Save
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default SettingsPage;